import EventEmitter from "eventemitter3"

class MapItem extends EventEmitter
{
  // ---------------------------------------------------------------------------------------------------------
	// --	MapItem
	// ---------------------------------------------------------------------------------------------------------

  constructor(id, label)
  {
    super()

    // console.log('MapItem:' + label + ' - ' + id)

    //IDトラベルを保持
    this.id = id
    this.label = label

    //選択状態フラグ
    this.isSelected = false

    //VIEWの配列
    this.views = []
  }

  /**
   * VIEWを追加
   */
  add(path)
  {
    path.hover(
      this.onRollOver.bind(this),
      this.onRollOut.bind(this)
    )
    path.click((e)=>{
      e.preventDefault()
      this.emit('SELECT', this.id)
    })
    
    this.views.push(path)
  }

  onRollOver()
  {
    this.updateView('#6EB4DC')
  }

  onRollOut()
  {
    if(this.isSelected)
    {
      this.updateView('#6EB4DC')
    }
    else
    {
      this.updateView('#B6D9ED')
    }
  }

  select(bool)
  {
    this.isSelected = bool

    if(this.isSelected)
    {
      this.updateView('#6EB4DC')
    }
    else
    {
      this.updateView('#B6D9ED')
    }
  }

  updateView(color)
  {
    let len = this.views.length
    for(let i=0; i<len; i++)
    {
      const path = this.views[i]
      path.css('fill', color)
    }
  }

  getBounds()
  {
    const mapOffset = $('.sc-schools__map').offset()
    const path = this.views[0]
    const pathOffset = path.offset()
    const pathRect = path[0].getBoundingClientRect()
    // console.log(pathRect)
    // console.log(pathOffset)

    return {
      top:pathOffset.top - mapOffset.top,
      left:pathOffset.left - mapOffset.left,
      width:pathRect.width,
      height:pathRect.height
    }
  }


  // ---------------------------------------------------------------------------------------------------------
}

export default MapItem
